import Api from "../../apiService";

class telemetryVehiclesApi {
  // Fleet возвращает freshness_status: { code, name, status, color, relative_time, received_at } даже без позиции.
  // Текст с временем и цвет готовит backend; frontend их не вычисляет.
  // current_day_mileage — километры за текущий день в timezone компании; null, если статистики ещё нет.
  // current_day_mileage_status — idle/low/normal/over_target/no_target по норме текущего автопарка.
  index(companyId, params = {}, config = {}) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/dashboard/fleet`,
      params,
      Api.authHeaders(),
      config
    );
  }

  selectOptions(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/vehicles/select_options`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, vehicleId) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/vehicles/${vehicleId}`,
      {},
      Api.authHeaders()
    );
  }
}

export default new telemetryVehiclesApi();
